export default "__VITE_ASSET__CjxbxbUV__"